import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const normalizeMediaItem = (mediaPlayback = {}, feedType) => {

    if (
        _isEmpty(mediaPlayback)
        || mediaPlayback === null
        || typeof mediaPlayback !== 'object'
    ) return {};

    const feeds = _get(mediaPlayback, 'feeds', []);
    const feed = feedType ? feeds.find(feed => feed.type === feedType) : feeds[0];

    return {
        ...mediaPlayback,
        ...feed,
        content_id: mediaPlayback.slug,
        date: mediaPlayback.date,
        prefetchNextItem: false,
    };

};

export default normalizeMediaItem;
